import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import HomePage from './pages/HomePage';
import Cadastro from './pages/Cadastro';
import Login from './pages/Login';
import ClienteDashboard from './pages/ClienteDashboard';
import FornecedorDashboard from './pages/FornecedorDashboard';
import AdminDashboard from './pages/AdminDashboard';
import PedidoDetalhes from './pages/PedidoDetalhes';
import OrcamentosPedido from './pages/OrcamentosPedido';
import PedidoDetalhesFornecedor from './pages/PedidoDetalhesFornecedor';
import EnviarOrcamento from './pages/EnviarOrcamento';
import FornecedorEscolhido from './pages/FornecedorEscolhido';
import OrcamentosCliente from './pages/OrcamentosCliente';
import Configuracoes from './pages/Configuracoes';
import AjudaPage from './pages/AjudaPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Toaster position="top-right" />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cadastro" element={<Cadastro />} />
          <Route path="/cliente/dashboard" element={<ClienteDashboard />} />
          <Route path="/fornecedor/dashboard" element={<FornecedorDashboard />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/cliente/orcamentos" element={<OrcamentosCliente />} />
          <Route path="/cliente/fornecedor/:id" element={<FornecedorEscolhido />} />
          <Route path="/cliente/pedidos/:id" element={<PedidoDetalhes />} />
          <Route path="/cliente/orcamentos/:id" element={<OrcamentosPedido />} />
          <Route path="/fornecedor/pedidos/:id" element={<PedidoDetalhesFornecedor />} />
          <Route path="/fornecedor/orcamento/:id" element={<EnviarOrcamento />} />
          <Route path="/configuracoes" element={<Configuracoes userType="cliente" />} />
          <Route path="/ajuda" element={<AjudaPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 